export type SubmissionCommentId = number;

export enum SubmissionCommentTargetType {
  LESSON_HOMEWORK_SUBMISSION = 'Online::LessonHomeworkSubmission',
  EXAM_PRACTICAL_SECTION_SUBMISSION = 'Online::PracticalSectionSubmission',
}
